/** Map API error codes to copy suitable for the sign-in UI. */
export function friendlyAuthError(
  error?: string,
  opts?: { message?: string; attemptsLeft?: number }
): string {
  const msg = String(opts?.message || "").trim();
  if (msg && !/^[a-z][a-z0-9_]*$/i.test(msg)) {
    return msg;
  }

  const code = String(error || msg || "").trim().toLowerCase();
  const left = opts?.attemptsLeft;

  switch (code) {
    case "invalid_code":
      if (typeof left === "number" && left > 0) {
        return `That code isn't correct. You have ${left} more ${left === 1 ? "try" : "tries"}.`;
      }
      return "That code isn't correct. Check the email we sent, or tap Resend email for a new code.";
    case "expired_or_missing":
      return "This code has expired. Tap Resend email to get a new link and code.";
    case "too_many_attempts":
      return "Too many incorrect attempts. Wait a minute, then tap Resend email to start over.";
    case "invalid_input":
      return "Enter the 4-digit code from your email.";
    case "invalid_email":
      return "Enter a valid email address.";
    case "terms_required":
      return "Please accept the Terms & Conditions to create an account.";
    case "registration_disabled":
      return "Registration is only available on the main dashboard. Sign in if you already have an account.";
    case "registration_failed":
    case "registration_unavailable":
      return "We could not create your account right now. Please try again.";
    case "rate_limited":
      return "Please wait a minute before requesting another email.";
    case "mailgun_not_configured":
    case "mailgun_disabled":
    case "email_failed":
    case "mailgun_api_error":
      return "We couldn't send the sign-in email right now. Try again shortly or contact your administrator.";
    case "login_failed":
    case "user_not_found":
      return "We couldn't sign you in. Check your email or ask an administrator for access.";
    case "forbidden":
      return "You don't have permission to sign in here.";
    default:
      if (code) {
        return "Something went wrong. Please try again.";
      }
      return "Something went wrong. Please try again.";
  }
}
